import React from "react";

import "./Footer.css";

export default function footer() {
  return <div className="footer">© Terence Ndime 2025 - 2026</div>;
}
